document.addEventListener("DOMContentLoaded", function () {
  document.querySelectorAll(".orbit-showcase").forEach(function (section) {
    const track = section.querySelector("[data-orbit-track]");
    if (!track) return;

    const cards = track.querySelectorAll("[data-orbit-card]");
    if (!cards.length) return;

    function slide(direction) {
      const card = cards[0];
      const gap = 20;
      const amount = card.getBoundingClientRect().width + gap;

      track.scrollBy({
        left: direction * amount,
        behavior: "smooth"
      });
    }

    section.querySelectorAll(
      "[data-orbit-next], [data-orbit-next-bottom]"
    ).forEach(function (button) {
      button.addEventListener("click", function () {
        slide(1);
      });
    });

    section.querySelectorAll(
      "[data-orbit-prev], [data-orbit-prev-bottom]"
    ).forEach(function (button) {
      button.addEventListener("click", function () {
        slide(-1);
      });
    });
  });
});

/* HUDDLO MOBILE MENU */
document.addEventListener('click', function (event) {
  var button = event.target.closest('[data-menu-toggle]');
  if (!button) return;

  var menu = document.querySelector('[data-mobile-nav]');
  if (!menu) return;

  var isOpen = menu.hidden || !menu.classList.contains('is-open');

  menu.hidden = !isOpen;
  menu.classList.toggle('is-open', isOpen);
  button.setAttribute('aria-expanded', String(isOpen));
});
